<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-12 09:18:40
 * @LastEditors: luckymiaow
 * @LastEditTime: 2023-07-10 15:16:25
-->

<script lang="ts" setup>
import { ref, useAttrs, watchEffect } from 'vue';
import { SelectOption as ASelectOption } from 'ant-design-vue';
import Select from '../../select/src/Select.vue';
import useForm from '../../form/src/useFormConfig';
import type { IBooleanSelect } from '../types';
import { FieldNames } from '../types';

const props = withDefaults(
  defineProps<{
    fieldNames?: FieldNames;
    value?: boolean;
  }>(),
  {
    fieldNames: () => new FieldNames(),
    bordered: true,
  }
);
const emit = defineEmits(['update:value', 'change']);

const { getBindValue } = useForm<IBooleanSelect>({ props, componentName: 'Select', attrs: useAttrs() });

const mValue = ref<any>(null);

function change(event: any) {
  let value = event;
  if (event != null) {
    value = event === props.fieldNames.true;
  }
  emit('update:value', value);
  emit('change', value);
}

watchEffect(() => {
  if (getBindValue.value?.value == null) {
    mValue.value = undefined;
  } else {
    mValue.value = getBindValue.value.value === true ? props.fieldNames.true : props.fieldNames.false;
  }
});
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <Select v-bind="getBindValue" v-model:value="mValue" :fieldNames="undefined" @change="change">
    <a-select-option :value="fieldNames.true">{{ fieldNames.true }} </a-select-option>
    <a-select-option :value="fieldNames.false">{{ fieldNames.false }} </a-select-option>
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </Select>
</template>
